import React, { useMemo } from 'react'
import { CommonDialog, CommonButton } from '@/components/common'
import { Cancel as CancelIcon } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { formatDateString } from '@/utils'

export const IneligibilityDialog = ({
  open,
  onClose,
  procedure,
  nextEligibilityDate,
}) => {
  const message1 = useMemo(() => {
    if (nextEligibilityDate === '9999-09-09' || !nextEligibilityDate)
      return `You are ineligible to donate ${procedure}.`
    return `You are ineligible to donate ${procedure} on the selected date.`
  }, [nextEligibilityDate, procedure])

  const message2 = useMemo(() => {
    if (nextEligibilityDate === '9999-09-09' || !nextEligibilityDate)
      return 'Please contact the blood center for more information.'
    return `You can donate again on ${formatDateString(nextEligibilityDate)}`
  }, [nextEligibilityDate])

  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      closable={false}
      maxWidth='xs'
      fullWidth
    >
      <Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CancelIcon
            sx={{
              fontSize: 52,
              color: 'primary.main',
            }}
          />
        </Box>
        <Box textAlign={'center'} mt={2}>
          <Typography variant='h6' color='error'>
            Not Eligible
          </Typography>
          <Typography variant='body1' sx={{ mt: 3 }}>
            {message1}
          </Typography>
          <Typography variant='body2' sx={{ mb: 3 }}>
            {message2}
          </Typography>
          <CommonButton variant='primary' onClick={onClose} sx={{ px: 4 }}>
            Ok
          </CommonButton>
        </Box>
      </Box>
    </CommonDialog>
  )
}
